declare const importMeta: ImportMeta

export const GEMINI_CONFIG = {
  apiKey: (import.meta as any).env?.VITE_GEMINI_API_KEY || '',
  baseUrl: (import.meta as any).env?.VITE_GEMINI_API_BASE || 'https://generativelanguage.googleapis.com/v1beta',
  model: (import.meta as any).env?.VITE_GEMINI_MODEL_ID || 'gemini-2.5-flash-lite',
  enabled: ((import.meta as any).env?.VITE_GEMINI_ENABLED ?? 'true') !== 'false',
}

export interface GeminiGenerateContentRequest {
  contents: Array<{
    role?: 'user' | 'model' | string
    parts: Array<{ text: string }>
  }>
}

export interface GeminiCandidatePart {
  text?: string
}

export interface GeminiCandidateContent {
  parts: GeminiCandidatePart[]
}

export interface GeminiGenerateContentResponse {
  candidates?: Array<{
    content?: GeminiCandidateContent
  }>
}





